module.exports = {"title":"사용자 수정","status":"상태","statusActive":"활성화","statusInactive":"비활성화","id":"아이디","name":"이름","phone":"휴대폰","email":"이메일","role":"권한","selectRolePlaceholder":"권한을 선택하세요.","assignedGolfClub":"담당 골프클럽","selectClubPlaceholder":"담당 골프클럽을 선택하세요.","searchKeywordPlaceholder":"검색어를 입력하세요.","activeClubListTooltip":"[설정 > 골프클럽 관리]에서 활성화 상태로 설정된 골프클럽 목록입니다.","roleAplManager":"APL관리자","roleAplMaster":"APL마스터","roleSktDeveloper":"SKT개발자","roleAplDeveloper":"APL개발자","roleClubManager":"클럽관리자","modified":"수정되었습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/ma004.json
// module id = yD4H
// module chunks = 2